exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex;\r\n    flex-grow: 1;\r\n}\r\n\r\n.kendo-tab-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-grow: 1;\r\n    height: 100%;\r\n}\r\n\r\n.kendo-grid {\r\n    height:100%;\r\n    overflow: auto;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/app/settings/settings-eventaction/settings-eventaction-color.component.css
// module id = 2422
// module chunks = 1